import useFaqState from './useFaqState'
import { IFaqArticle } from '../faq.types'
import { useMemo } from 'react'

const useFaqArticle = (id: IFaqArticle['id']) => {
  const { articles } = useFaqState()

  return useMemo(() => {
    return articles.find((c) => c.id === id)
  }, [articles, id])
}

export default useFaqArticle
